import RuleActionModel from '@/common/models/rules/actions/rule-action-model';
import SendWebhookPreviewModel from '@/common/models/send-webhook-preview-model';
import BindModel from '@/common/models/rules/bind-model';
import IntegrationModel from '@/common/models/integration-model';

const integrationPrefix = `${IntegrationModel.Services.googleSheets}:`;
const titlePrefix = 'Update ';

export function generateFieldsTemplate(selectedFields) {
    return selectedFields.map(field => `{{ ${field.value} }}`);
}

export function parseFieldsTemplate(eventFields, templates) {
    const templatesFields = templates.map(placeholder => placeholder.replace(/(^{{\s|\s}}$)/gi, ''));

    return eventFields.filter(({value}) => templatesFields.includes(value));
}

export function parseRuleSet(ruleSet, eventFields) {
    const bind = ruleSet.binds.find(b => b.labels.find(l => l.startsWith(integrationPrefix)));

    if (!bind) {
        throw new Error('Rule set does not contain google sheets bind');
    }

    const googleSheetId = bind.labels.find(l => l.startsWith(integrationPrefix)).replace(integrationPrefix, '');
    const googleSheetName = bind.name.replace(titlePrefix, '');
    const eventCriteria = bind.criteria;
    const {credentialHash, body} = bind.actions[0];
    const selectedFields = parseFieldsTemplate(eventFields, JSON.parse(body).values[0]);

    return {
        credentialHash,
        googleSheetId,
        googleSheetName,
        eventCriteria,
        selectedFields,
    };
}

export function buildWebhook(
    {
        credentialHash,
        googleSheetId,
        eventType,
        selectedEventFields,
    },
) {
    return new SendWebhookPreviewModel({
        eventType,
        credentialHash,
        method: 'POST',
        headers: [{
            name: 'content-type',
            status: 'active',
            value: 'application/json',
        }],
        url: `https://sheets.googleapis.com/v4/spreadsheets/${googleSheetId}/values/A1:append?insertDataOption=INSERT_ROWS&valueInputOption=RAW`,
        body: JSON.stringify(
            {
                values: [generateFieldsTemplate(selectedEventFields)],
            },
        ),
    });
}

export function buildBind(
    {
        credentialHash,
        googleSheetId,
        googleSheetName,
        eventType,
        eventCriteria,
        selectedEventFields,
    },
) {
    return new BindModel({
        name: `${titlePrefix}${googleSheetName}`,
        labels: [`${integrationPrefix}${googleSheetId}`],
        status: BindModel.Statuses.active,
        actions: [{
            name: RuleActionModel.Names.triggerWebhook,
            status: RuleActionModel.Statuses.active,
            // Event type is part of webhook preview payload only,
            // it's not exists and ignored in trigger-webhook rule action.
            ...buildWebhook(
                {
                    credentialHash,
                    googleSheetId,
                    eventType,
                    selectedEventFields,
                },
            ),
        }],
        criteria: eventCriteria
            ? eventCriteria.getPayload()
            : null,
    });
}

// TODO: Filter only specific bind in configuration by labels.
// eslint-disable-next-line no-unused-vars
export function removeIntegration(ruleSet, configuration) {
    ruleSet.binds = ruleSet.binds.filter(
        bind => bind.labels.find(label => !label.startsWith(integrationPrefix)),
    );
}

export function insertIntegration(ruleSet, bind) {
    ruleSet.binds.push(bind);
}
